import { ApiBestPricePackageModel, ApiBooking } from '@ibe/api';

export default class CheckoutFailedEvent {
  constructor(
    public booking: ApiBooking | null,
    public packageItem?: ApiBestPricePackageModel,
    public numberOfPersons?: number
  ) {}
}
